import { defineComponent as r, openBlock as n, createBlock as a, unref as p, mergeProps as m, withCtx as c, createElementVNode as f } from "vue";
import { RevIcon as l } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconArrowUpLeft",
  __name: "IconArrowUpLeft",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (n(), a(p(l), m(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        f("path", { d: "M12.707 6.386a.75.75 0 0 0 0-1.5H6.136a1.25 1.25 0 0 0-1.25 1.25v6.571a.75.75 0 0 0 1.5 0v-5.26l11.448 11.447a.75.75 0 1 0 1.06-1.06L7.447 6.386h5.26" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
